module.exports = __webpack_public_path__ + "img/foto_7.9b4cc600.jpg";